// функция генерации рандомного id
export function createRandomId(): string {
    const glue = '-';
    const mask = 1e16;

    return Date.now() + glue + Math.round(Math.random() * mask);
}
